<template>
  <div>
    <form @submit.prevent="submitFilters">
      <div class="row">
        <div class="col-12 col-md-6">
          <label class="akkurate-dark small" for="date">From Date</label>
          <b-form-group label-for="start_date" class="akkurate-dark">
            <b-form-input id="start_date" class="mt-2 field-container fields" type="date" v-model="form.start_date">
            </b-form-input>
          </b-form-group>
        </div>

        <div class="col-12 col-md-6">
          <label class="akkurate-dark small" for="date">To Date</label>
          <b-form-group label-for="end_date" class="akkurate-dark">
            <b-form-input id="end_date" class="mt-2 field-container fields" type="date" v-model="form.end_date">
            </b-form-input>
          </b-form-group>
        </div>

        <div class="col-12 col-md-6">
          <label class="akkurate-dark small" for="search">Transaction Type</label>
          <b-form-group id="transaction_type" label-for="transaction_type" class="akkurate-dark">
            <multiselect class="mt-2 field-container" v-model="form.transaction_type" :options="transaction_types"
              selectLabel="" deselectLabel="">
            </multiselect>
          </b-form-group>
        </div>
        <div class="col-12 col-md-6">
          <label class="akkurate-dark small" for="status">Status</label>
          <b-form-group id="status" label-for="status" class="akkurate-dark">
            <multiselect class="mt-2 field-container" v-model="form.status" :options="statuses"
              placeholder="Select status" selectLabel="" deselectLabel="">
            </multiselect>
          </b-form-group>
        </div>

        <div class="col-12 col-md-6">
          <label class="akkurate-dark small" for="trans_source">Source</label>
          <multiselect class="field-container mt-2" v-model="form.trans_source" :options="trans_source_options"
            placeholder="Transaction Source" label="name" selectLabel="" deselectLabel="">
          </multiselect>
        </div>



        <div class="col-12 col-md-6">
          <!-- <label class="akkurate-dark small" for="branch">Branch</label>
          <multiselect class="mt-2 field-container" :multiple="true" :close-on-select="false" :clear-on-select="false"
            v-model="form.branch" :options="branch_option" track-by="name" placeholder="Select one" selectLabel=""
            deselectLabel="" label="name">
          </multiselect> -->
          <label class="akkurate-dark small" for="branch">Branch</label>
          <b-form-group id="branch" label-for="branch" class="akkurate-dark">
            <multiselect v-model="form.branch" :options="branch_option" :multiple="true" placeholder="Select Branch"
              :close-on-select="false" label="name" :clear-on-select="false" class="mt-2 field-container"
              track-by="name">
              <template slot="selection">
                <span class="multiselect__single" v-if="form.branch.length">{{ form.branch.length }}
                  options
                  selected</span>
              </template>
            </multiselect>
            <div class="akkurate-small">{{ getBranch }}</div>
          </b-form-group>
        </div>

        <div class="col-12 col-md-6">
          <label class="akkurate-dark small" for="term">Terms</label>
          <multiselect class="mt-2 field-container" v-model="form.term" :options="terms_option" placeholder="Select one"
            selectLabel="" deselectLabel="">
          </multiselect>
        </div>

        <div class="col-12 col-md-6">
          <label class="akkurate-dark small" for="transaction_mode">Transaction Mode</label>
          <multiselect class="mt-2 field-container" :multiple="true" :close-on-select="false" :clear-on-select="false"
            v-model="form.transaction_mode" :options="transaction_mode_option" placeholder="Select one" selectLabel=""
            deselectLabel="">
          </multiselect>
        </div>

        <!-- <div class="d-grid gap-2 col-md-2 mt-auto d-flex align-content-center justify-content-center">
          <b-button type="submit" class="akkurate-green-btn akkurate-auth-size w-100"><i
              class="fas fa-search me-2"></i>Search</b-button>
          <b-button size="sm" @click="show_more" title="show more filters" class="ms-2">
            <i class="fas fa-bars akkurate-small"></i>
          </b-button>
        </div> -->
      </div>
    </form>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
  components: {
    Multiselect
  },
  props: ['form', 'users', 'acc_types_option', 'branch_option'],
  computed: {
    getBranch() {
      if (this.form.branch.length > 0) {
        const result = this.form.branch.map((index) => {
          return index.name
        });
        // console.log(result);
        return result.join(" | "); // Join array elements with ", "
      } else {
        return "";
      }
    }
  },
  data() {
    return {
      more_details: false,
      // transaction_options: ['Deposit', 'Withdrawal'],
      // sources: ['Mobile', 'WEB', 'USSD']
      statuses: ['COMPLETED', 'PENDING', 'REVERSED', 'REJECTED'],
      transaction_types: ['FD Deposit', 'FD Withdrawal',],
      terms_option: ['YTD', 'Periodic','Trashed'],
      transaction_mode_option: ['Cash', 'Cheque', 'Transfer'],
      // sources: [{ name: 'USSD', id: "USSD" }, { name: 'WEB', id: "WEB" }, { name: 'MOBILE BANKER', id: "Mobile_Banker" }],
      // code_option: [
      //   { name: "Customer code", value: "filter" },
      //   { name: "Account #", value: "account_number" },
      //   { name: "Ref.No", value: "code" },
      //   { name: "Mobile", value: "phone_number" },
      // ],
      trans_source_options: [
        { name: 'USSD', value: "ussd" },
        { name: 'OFFICE', value: "office" },
        { name: 'MOBILE', value: "mobile" },
        // { name: 'Deposit', value: "deposit" },
        // { name: 'Withdrawal', value: "withdrawal" },
      ],
      // trans_sources: ["Deposit", "Withdrawal"]

    }
  },
  methods: {
    submitFilters() {
      this.$emit("submitFilters");
    },



    show_more() {
      this.more_details = !this.more_details
    }
  }
}

</script>